<script>
// important =================== invoiceId === CustomerID

import Layout from "../../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../../app.config";
import axios from 'axios';
import Select2 from 'vue3-select2-component';
import DataTable from 'datatables.net-vue3';
//import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import "@vueform/multiselect/themes/default.css";
import Swal from "sweetalert2";

export default {
    emits: ['select'],

    page: {
        title: "Instant Pay list",
        meta: [{ name: "description", content: appConfig.description }],
    },

    data() {
        return {
            role:localStorage.getItem('role'),
            title: "Create Credit Note",
            items: [
                {
                text: "Create Credit Note",
                href: "/",
                },
            ],

            CustomerName:'',
            issue_date:this.getTodayDate(),
            amount:'',
            reason:'',
            listCustomer:[],
            InvoiceDetail:[],
            listInvoice:[],
            loadingRoles:false,
            showdata:false,
            inputEmpty:false,

            FromInvoiceList:false,
            selectShowInv:false,
            invoice_id:[],
            selectAll: false,
            NotSelect: false,
            selectMoreThanOne: false,
            selectedOption:'',

            
        };
    },
    
    methods: {
        getListCreditNote(){
            if(this.CustomerName == ''){
                alert('Please Select Customer.');
                this.inputEmpty = false;
            }
            else{
                this.inputEmpty = true;
                this.showdata =false;
                this.loadingRoles=true;
                axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                axios.get(process.env.VUE_APP_AR_API_BASEURL+'creditnotes/invoice/'+this.CustomerName)
                // axios.get('https://sw-uat.renewplus.my:3008/api/creditnotes/invoice/'+this.CustomerName)
                .then(response => {
                    this.selectShowInv = true;
                    this.loadingRoles=false;
                    if (response) {
                        this.showdata = true;
                        this.listInvoice = response.data;
                    } 
                    else {
                        this.messageBag = ['No record.'];
                    }
                })
                .catch(error => {
                    this.loadingRoles=false;
                    this.selectShowInv=false;
                    this.messageBag = [error.error];
                });
            }
        },

        sanitizeInput() {
            this.amount = this.amount.replace(/[^\d.]/g, '');
            const dotIndex = this.amount.indexOf('.');
            if (dotIndex !== -1) {
                const remainingString = this.amount.slice(dotIndex + 1);
                const dotCount = (remainingString.match(/\./g) || []).length;
                if (dotCount > 0) {
                    this.amount = this.amount.slice(0, dotIndex + 1);
                }
            }
        },

        generate(){
            if(this.CustomerName == ''){
                alert('Please Select Customer.');
            }
            else if(this.reason == ''){
                alert('Please Select Reason.');
            }
            else if(this.amount == ''){
                alert('Please Enter Amount.');
            }
            else{

                // alert("min"+this.minimumValue);
                // alert("max"+this.maxValue);
                // console.log(this.minimumValue);
                // console.log(this.maxValue);
                // console.log(this.amount);
                if(this.minimumValue == this.maxValue||(this.minimumValue<=this.amount && this.maxValue >= this.amount)){
                    Swal.fire({
                        title: "Are you sure you want to create this credit note?",
                        icon: "info",
                        showCancelButton: true,
                        cancelButtonColor: "#f46a6a",
                        confirmButtonColor: "#34c38f",
                        confirmButtonText: "Yes, create credit note",
                    }).then((result) => {
                        if (result.value) {
                            const posting_ = {
                                'CustomerName'  : this.CustomerName,
                                'issue_date'    : this.issue_date,
                                'reason'        : this.reason,
                                'amount'        : this.amount,
                                'invoice_id'    : this.invoice_id,
                            };
                            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                            axios.post(process.env.VUE_APP_AR_API_BASEURL+'creditnotes/create', posting_ )
                            .then(response => {
                                // console.log(response);
                                if (response.status == 201||response.status == 200) {
                                    Swal.fire({
                                        title:"Credit note created!", 
                                        // html: "Email successfully send.", 
                                        icon:"success",
                                    })
                                    this.getListCreditNote();
                                } 
                                else {
                                    Swal.fire({
                                        title:"Credit note failed to create!", 
                                        // html: "Email successfully send.", 
                                        icon:"warning",
                                    })
                                }
                            }).catch(function (error) {                    
                                Swal.fire({
                                    title:error.response.data.msj, 
                                    // html: "Email successfully send.", 
                                    icon:"warning",
                                })
                            });
                        }
                    });
                }
            }
        },

        checkName(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_AR_API_BASEURL+'customer/list')
            // axios.get('https://sw-uat.renewplus.my:3008/api/customer/list')
            .then(response => {
                if (response.data) {
                   this.listCustomer=response.data;
                } 
                else {
                    this.messageBag = ['No record.'];
                    this.listCustomer=[];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        getDetailInvoice(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_AR_API_BASEURL+'invoice/customers/'+ this.$route.params.invoiceId)
            .then(response => {
                if (response.data) {
                   this.InvoiceDetail=response.data;
                   this.CustomerName = response.data.customer_id;
                   this.getListCreditNote();
                } 
                else {
                    this.messageBag = ['No record.'];
                    this.InvoiceDetail=[];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        checkorder() {
            if (this.order_id.length > 11) {
                this.searchorderId();
                this.getListCreditNote();
            }
        },

        getTodayDate() {
            const today = new Date();
            return today.toISOString().slice(0, 10);
        },

        formatCurrency(value) {
            let val = (value/1).toFixed(2)
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },

        calculateBalance(item) {
            const value = parseFloat(item.total_amount) - parseFloat(item.over_pay) - parseFloat(item.credits_applied) + parseFloat(item.late_payment_charges) - parseFloat(item.paid_amount);
            return parseFloat(value.toFixed(2));
        },
        selectAllItems() {
            if (this.selectAll) {
                this.invoice_id = this.listInvoice.map(item => item.id);
            } else {
                this.invoice_id = [];
            }
        },

        goBack() {
            this.$router.back();
        },
    },

    computed: {
        maxValue() {
            let sum = 0;
            for (const id of this.invoice_id) {
                const item = this.listInvoice.find(invoice => invoice.id === id);
                if (item) {
                sum += parseFloat(this.calculateBalance(item));
                }
            }
            return parseFloat(sum.toFixed(2));
        },

        minimumValue() {
            if (this.invoice_id.length === 1) {
                return 0;
            }
            // Calculate minimum value based on selected items
            let min = Infinity;
            for (const id of this.invoice_id) {
                // console.log('masuk')
                const item = this.listInvoice.find(invoice => invoice.id === id);
                if (item) {
                    // console.log('masuk 1')
                    const balance = parseFloat(this.calculateBalance(item));
                    if (balance < min) {
                        // console.log('masuk 2')
                        min = balance + 1;
                    }
                }
            }
            return min !== Infinity ? min : 0; // Return 0 if no items are selected
        },
    },

    watch: {
        invoice_id(newValue) {
            if (newValue.length > 1) {
                // console.log('1');
                this.selectMoreThanOne = true;
            }else{
                // console.log('2');
                this.NotSelect = true;
                this.selectMoreThanOne = false;
            }
        },

        CustomerName(){
            this.invoice_id=[];
            this.getListCreditNote();
        }
    },

    components: {
        Layout,
        PageHeader,
        Select2, 
        DataTable,
        
    },

    mounted() {

        if (typeof this.$route.params.invoiceId !== 'undefined') {
        this.FromInvoiceList = true;
        this.getDetailInvoice();
        }
        this.checkName();
    },
    
};
require("@/assets/css/datatable.css");
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <div class="live-preview">
                        <div class="row gy-4">
                            <div class="col-md-6">
                                <div >
                                    <label for="basiInput" class="form-label " >Customer Name <span style="color: red;">*</span></label>
                                    <Select2 v-model="CustomerName" :options="listCustomer" ></Select2>
                                </div>
                            </div>
                            <!--end col-->
                            <div class="col-md-6">
                                <div>
                                    <label for="labelInput" class="form-label">Issue Date <span style="color: red;">*</span></label>
                                    <input type="date" class="form-control" v-model="issue_date" readonly>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div>
                                    <label for="labelInput" class="form-label">Reason <span style="color: red;">*</span></label>
                                    <select class="form-select mb-3"  v-model='reason' placeholder=""> required>
                                        <option value="" selected disabled>Select Reason</option>
                                        <option value="Late Charge" selected >Late Charge</option>
                                        <option value="Extra payment" selected >Extra payment</option>
                                        <option value="Campaign Waiver" selected >Campaign Waiver</option>
                                        <option value="Full Settlement - 1 Month Instalment Waiver" selected >Full Settlement - 1 Month Instalment Waiver</option>
                                        <option value="Full Settlement - 2 Month Instalment Waiver" selected >Full Settlement - 2 Month Instalment Waiverr</option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div>
                                    <label for="labelInput" class="form-label">Amount (RM) <span style="color: red;">*</span></label>
                                    <input type="text" class="form-control" v-model="amount" @input="sanitizeInput">
                                    <div v-if="amount != 0 && NotSelect == true">
                                        <p style="color:red">
                                            <span v-if="selectMoreThanOne">Min Amount: RM {{ minimumValue }} &nbsp; </span>
                                            <span v-if="(maxValue != 0)"> Max Amount {{ maxValue }} </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div v-if='loadingRoles'>
                        <div class="spinner-border text-success" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                    <div v-else>
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="card"  v-if="selectShowInv">
                                    <div class="card-header align-items-center d-flex">
                                        <h4 class="card-title mb-0 flex-grow-1">Invoice List</h4>
                                    </div>
                                    <!-- end card header -->
                                    <div class="card-body">
                                        <div class="table-responsive">

                                            <DataTable :options="{lengthChange: false,searching: false}" :key="dtKey" class="table table-striped table-nowrap mb-0" id="example"> 
                                                <thead class="table-secondary">
                                                    <tr>
                                                        <th>#.</th>          
                                                        <th scope="col">Ref. No</th>
                                                        <th scope="col">Issued Date</th>
                                                        <th scope="col">Monthly Amount (RM)</th>
                                                        <th scope="col">Overpaid Amount (RM)</th>
                                                        <th scope="col">Late Payment Charge (RM)</th>
                                                        <!-- <th scope="col">Total (RM)</th> -->
                                                        <th scope="col">Paid Amount (RM)</th>
                                                        <th scope="col">Credit Amount (RM)</th>
                                                        <!--th scope="col">Late Charge (RM)</th-->
                                                        <th scope="col">Balance Amount (RM)</th>  
                                                    </tr>
                                                </thead>

                                                <tbody>                        
                                                    <tr v-for="(item, index) in listInvoice" :key="index" class="content">
                                                        <td>{{ index + 1 }} <input type="checkbox" :value="item.id" v-model="invoice_id" v-if="calculateBalance(item) !== 0"></td>
                                                        <td>{{item.invoice_no}}</td>
                                                        <td>{{item.issue_date}}</td>
                                                        <td>{{item.total_amount}}</td>
                                                        <td>{{ parseFloat(item.over_pay).toFixed(2) }}</td>
                                                        <td>{{ item.late_payment_charges }}</td>
                                                        <!-- <td>{{ (parseFloat(item.total_amount) + parseFloat(item.late_payment_charges)).toFixed(2) }}</td> -->
                                                        <td>{{item.paid_amount}}</td>
                                                        <td>{{item.credits_applied}}</td>
                                                        <!--td>{{item.late_payment_charges}}</td-->
                                                        <td>                                                         
                                                            <!-- <span v-if="item.paid_amount == 0">{{ parseFloat(calculateBalance(item)).toFixed(2) }}</span> -->
                                                            <span v-if="calculateBalance(item) > 0" style="color:red;">
                                                                ( {{ parseFloat(calculateBalance(item)).toFixed(2) }} )
                                                            </span>
                                                            <span v-else>
                                                                {{ parseFloat(calculateBalance(item)).toFixed(2) }}
                                                            </span>
                                                        </td>   
                                                    </tr>
                                                </tbody>
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row g-3 justify-content-end p-3">
                    <div class="col-sm-2">
                        <div>
                            <div @click="goBack">
                                <button class="btn btn-success w-100">Cancel</button>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <div>
                            <button type="button" @click="generate" class="btn btn-primary w-100">
                                <i class="me-2 align-bottom"></i>Create Credit Note
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    
    <!-- <div v-else>
        Please select Customer Name
    </div> -->

            
    </Layout>
</template>